import React from "react";
import { useSearchParams } from "react-router-dom";
import DesktopFilterSidebar from "./WindowFilterSidebar";
import MobileFilterSidebar from "./MobileFilterSidebar";
import { ISidebarFilters } from "Interfaces/interface.filter";

const SidebarFilters: React.FC<ISidebarFilters> = ({
  clearFilter,
  showClear,
  filterData,
  handleFilter,
  facets,
  loading,
  categories,
  onOpenModal,
  selectedCategoryIds,
  selectedSubCategoryIds,
  selectedBrandIds,
  onCategoryChange,
  onSubCategoryChange,
  onBrandChange,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div>
      {/* Desktop */}
      <div className="hidden lg:block">
        <DesktopFilterSidebar
          clearFilter={clearFilter}
          showClear={showClear}
          filterData={filterData}
          handleFilter={handleFilter}
          facets={facets}
          loading={loading}
          categories={categories}
          selectedCategoryIds={selectedCategoryIds}
          selectedSubCategoryIds={selectedSubCategoryIds}
          selectedBrandIds={selectedBrandIds}
          onCategoryChange={onCategoryChange}
          onSubCategoryChange={onSubCategoryChange}
          onBrandChange={onBrandChange}
        />
      </div>

      {/* Mobile */}
      <div className="lg:hidden">
        <MobileFilterSidebar
          showClear={showClear}
          clearFilter={clearFilter}
          filterData={filterData}
          handleFilter={handleFilter}
          facets={facets}
          loading={loading}
          categories={categories}
          onOpenModal={onOpenModal}
          selectedCategoryIds={selectedCategoryIds}
          selectedSubCategoryIds={selectedSubCategoryIds}
          selectedBrandIds={selectedBrandIds}
          onCategoryChange={onCategoryChange}
          onSubCategoryChange={onSubCategoryChange}
          onBrandChange={onBrandChange}
        />
      </div>
    </div>
  );
};

export default SidebarFilters;
